<template lang="pug">
    div
        v-card-text
            v-text-field(readonly label="Movimiento" :value="typeMovement")
            v-text-field(readonly label="Fecha" :value="date")
            v-text-field(readonly
                :label="typeMovement != 'Apertura de caja' ? 'Monto' : 'Monto inicial' "
                :value="cashAmount" prefix="$"
                :mask="mixCurrencyMask(cashAmount, 12)")
            //- v-text-field(v-if="" readonly
            //-     label="Motivo" :value="reason")
            v-text-field(readonly
                label="Comentario" :value="comment")
        v-divider

</template>

<script>
import SupervisorUniqueKey from '@/components/SupervisorUniqueKey/SupervisorUniqueKey'
import CurrencyUtils from '@/mixins/CurrencyUtils'
//import VerificationCode from '@/mixins/VerificationCode'
import Colors from '@/mixins/Colors'
import { mapState, mapActions } from 'vuex'
export default {
    name: 'modal-cash-movement-content',
    props: {},
    data: function() {
        return {
            show: false,
        }
    },
    computed: {
        ...mapState('CashMovementModule', {
            typeMovement: 'typeMovement',
            date: 'date',
            cashAmount: 'cashAmount',
            comment: 'comment',
            //reason: 'reason',
        }),

        ...mapState('UniqueKeyModule', {
            uniqueKey: 'uniqueKey',
        }),

        filledCode: function() {
            return this.uniqueKey.length === 3
        },
    },
    methods: {
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
        }),

        ...mapActions('CashMovementModule', {
            //authorize: 'authorize',
            resetStateCashMovementModule: 'resetState'
        }),

        cleanForm(){
            this.show = false
            this.resetStateCashMovementModule()
            this.$emit('clearform')
        },

        
    },
    mixins: [CurrencyUtils, /*VerificationCode,*/ Colors],
    components: { SupervisorUniqueKey },
}
</script>

<style lang="scss">
</style>